/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import {
  RECEIVED_API_KEY,
  RECEIVED_USER_AUTHENTICATION,
  ADD_VENDOR_SESSION,
  EXPIRE_VENDOR_SESSION,
  STORE_QUERY_PARAMS,
  SET_APP_ENTRYPOINT
} from 'state/session/SessionActions';

export const sessionInitialState = {
  apiKey: null,
  query: {
    params: {}
  },
  userId: null,
  entitlements: [],
  appEntryPoint: null,
  vendorSessions: []
};

export const sessionReducer = (state = sessionInitialState, action) => {
  if (action.type === RECEIVED_API_KEY) {
    return {
      ...state,
      apiKey: action.apiKey
    };
  }

  if (action.type === RECEIVED_USER_AUTHENTICATION) {
    return {
      ...state,
      userId: action.userId,
      entitlements: action.entitlements
    };
  }

  if (action.type === STORE_QUERY_PARAMS) {
    return {
      ...state,
      query: {
        params: {
          ...action.params
        }
      }
    };
  }

  if (action.type === SET_APP_ENTRYPOINT) {
    return {
      ...state,
      appEntryPoint: action.page
    };
  }

  if (action.type === ADD_VENDOR_SESSION) {
    const { vendorSession } = action;
    const existingItem = state.vendorSessions.some(
      (session) => session.name === vendorSession.name
    );
    if (existingItem) {
      return {
        ...state,
        vendorSessions: state.vendorSessions.map((session) => {
          if (session && session.name == vendorSession.name) {
            return {
              ...session,
              active: true
            };
          }
          return session;
        })
      };
    }
    return {
      ...state,
      vendorSessions: state.vendorSessions.concat(vendorSession)
    };
  }

  if (action.type === EXPIRE_VENDOR_SESSION) {
    return {
      ...state,
      vendorSessions: state.vendorSessions.map((session) => {
        if (session && session.name !== action.vendorName) {
          return session;
        }
        return {
          ...session,
          active: false
        };
      })
    };
  }

  return state;
};

sessionReducer.priority = 1;
